<template>
  <div class="store-cancel-notice">
    <h2 class="h3 mb-2"><b>{{ title }}</b></h2>
    <p class="mb-0">{{ body }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{ title: string; body: string }>();
</script>
